import React from 'react';
import styled from 'styled-components';
import { typography } from '../../../styled';
import { BookingQuizCategory, CATEGORY_ICONS } from '..';

const {
  serif: {
    copy: { Large }
  },
  sans: {
    copy: { Medium }
  }
} = typography;

interface Props {
  text: string;
  category?: BookingQuizCategory;
}

const Option = ({ text, category }: Props) => {
  return category ? (
    <LargeOption>
      {CATEGORY_ICONS[category] && <LargeOptionIcon>{CATEGORY_ICONS[category]}</LargeOptionIcon>}
      <span>{text}</span>
    </LargeOption>
  ) : (
    <Medium>{text}</Medium>
  );
};

export default Option;

const LargeOption = styled(Large)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const LargeOptionIcon = styled.span`
  margin-top: 0.75em;
`;
